export default __webpack_public_path__ + "static/media/radio-en-empty.d123acf4.svg";